import { GoogleAuthenticatorApi } from "../api";

const TwoFactorAuthService = {
    generateSecret: async (email: string) => {
        try {
            const response = await GoogleAuthenticatorApi.addCustom(`/generate/${email}`, {});
            return response.data;
        } catch (error: any) {
            throw { message: error.response?.data?.message || "Error al generar el código QR" };
        }
    },

    verifyCode: async (email: string, code: string) => {
        try {
            const response = await GoogleAuthenticatorApi.addCustom("/verify", { email, code });
            return response.data;
        } catch (error: any) {
            throw { message: error.response?.data?.message || "Código incorrecto" };
        }
    },

    disable2FA: async (email: string) => {
        try {
            const response = await GoogleAuthenticatorApi.addWithoutData(`/disable?email=${email}`)
            return response.data;
        } catch (error) {
            throw { message: error.response?.data?.message || "Error al desactivar 2FA" };
        }
    },

    check2FAStatus: async (email: string) => {
        try {
            const response = await GoogleAuthenticatorApi.fetchCustom(`/status?email=${email}`)
            return response.data;
        } catch (error: any) {
            throw { message: error.response?.data?.message || "Error al " };
        }
    }
};

export default TwoFactorAuthService;
